const fetchMachineInfo = async (org_id, machine_id) => {
    return fetch(`/dashboard/organizations/${org_id}/fleet/${machine_id}.json`)
        .then(r => r.json());
}

const aiConversation = async (org_id, machine_id) => {
    return fetch(`/dashboard/organizations/${org_id}/fleet/${machine_id}.json`)
        .then(r => r.json());
}
const fetchMachineIncidents = async (org_id, machine_id, params) => {
    const {from, to, chart, status} = params;
    console.log(from, to);
    let url = `/dashboard/organizations/${org_id}/fleet/${machine_id}/machine_incidents.json?from=${from}&to=${to}`;
    if (chart)
        url += `&chart=${chart}`;
    return fetch(url)
        .then(r => r.json());
}


export {fetchMachineInfo, fetchMachineIncidents}